var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12321 7.23646C5.01303 7.1109 4.96015 6.95918 4.96456 6.78131C4.96933 6.60343 5.02681 6.45171 5.13698 6.32615L6.69323 4.55261H0.550883C0.394799 4.55261 0.263873 4.49234 0.158103 4.3718C0.0527012 4.25168 0 4.10268 0 3.9248C0 3.74693 0.0527012 3.59772 0.158103 3.47718C0.263873 3.35706 0.394799 3.297 0.550883 3.297H6.69323L5.12321 1.50776C5.01303 1.3822 4.95795 1.233 4.95795 1.06014C4.95795 0.887704 5.01303 0.738706 5.12321 0.613145C5.23339 0.487585 5.36431 0.424805 5.51599 0.424805C5.6673 0.424805 5.79804 0.487585 5.90822 0.613145L8.42851 3.48534C8.48359 3.54812 8.52271 3.61613 8.54585 3.68938C8.56862 3.76262 8.58 3.8411 8.58 3.9248C8.58 4.00851 8.56862 4.08699 8.54585 4.16023C8.52271 4.23347 8.48359 4.30149 8.42851 4.36427L5.89445 7.25216C5.79345 7.36726 5.6673 7.4248 5.51599 7.4248C5.36431 7.4248 5.23339 7.36202 5.12321 7.23646Z",
    fill: "#1B4597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.af24d4e02017a78eaeb98d941cf33b71.svg";
export { ForwardRef as ReactComponent };